export default {
	setUserinfo(state,data){
        state.userinfo = data
    },
    setUserrich(state,data){
        state.userrich = data
    },
    setLoginState(state,data){
        state.login_state = data
    },
    setShowLogin(state,data){
        state.showlogin = data
    },
    setAnchor(state,data){
        state.anchor = data
    },
    showAnchor(state,data){
        state.show_anchor = data
    },
    showRealAnchor(state,data){
        state.show_realAnchor = data
    },
    setRealList(state,data){
        state.reallist = data
    },
    setDemoList(state,data){
        state.demolist = data
    },
    setAnchorList(state,data){
        state.anchor_list = data
    },
    setShowPloy(state,data){
        state.show_ploy = data
    },
    showOpenvip(state,data){   
        state.viptab = data.tab
        state.show_openvip = data.val
    },
    setRealAnchor(state,data){
        state.real_anchor = data 
    },
    setAllRealAnchor(state,data){
        state.allrealist = data 
    },
    setChoseMusic(state,data){
        state.chose_music = data 
    },
    setBgdMusic(state,data){
        state.bgd_music = data 
    },
    setAllMusics(state,data){
        state.allMusic = data
    },
    setIsBind(state,data){
        state.isbind = data 
    },
    setJbList(state,data){
        state.jblist = data 
    },
    setTtsJbList(state,data){
        state.ttsjblist = data 
    },
    setZifubao(state,data){
        state.zifubao = data 
    },
    setQd(state,data){
        state.qd = data
    },
    setUid(state,data){
        state.uid = data
    }
}


// WEBPACK FOOTER //
// ./src/store/mutations.js